<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title">The Military Memoirs of a Confederate Line Officer</h1>
<p class="subtitle">Captain John C. Reed’s Civil War from Manassas to Appomattox</p>
<p class="author">William R. Cobb, Editor</p>
<div class="image_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?a2261806